



//请求消费记录列表
export const COST_REQ = 'COST_REQ'

//处理消费记录列表
export const COST_HANDLE = 'COST_HANDLE'
